/**
 * Created by amir on 6/19/17.
 */
function requestsErrorHandlerFactory($q, $injector, toaster) {

    return {

            'request': function(config) {
                let ModalDialogService = $injector.get('ModalDialogService');
                // do something on success
                if(config.method == 'PATCH' || config.method == "PUT" || config.method == "POST") {
                    ModalDialogService.saveLastRelevantRequestFromServer(config);
                }
              return config;
            },

        // Intercept 403s and pop up modal for reconnection.
        responseError: function (response) {
            let ModalDialogService = $injector.get('ModalDialogService');
            let data = response.data;

            let popError = function (message = "An error has occurred") {
                toaster.clear();
                toaster.pop("error", null, message, 2500)
            };

            if(response.status >= 500 && response.status <= 599 && response.config.method == "GET") {
                return $q.reject(response);
            }

            if (_.isObject(data)) {
                if (hasOwnProperty.call(data, 'message')) {
                    if (response.status == 403 && data.message.includes('Wrong credentials') == true &&
                        ModalDialogService.active == true && ModalDialogService.isModalClosed == true) {
                        ModalDialogService.open();
                    }
                    else {
                        popError(data.message);
                    }
                }
                else if (hasOwnProperty.call(data, 'detail')) {

                    popError(data.detail);
                }
            }
            return $q.reject(response);
        }
    };
}

requestsErrorHandlerFactory.$inject = [
    '$q', '$injector', 'toaster'
];

export default requestsErrorHandlerFactory;


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/requests.error.handler.js
 **/